import { UnknownBlueprint } from '../types';

export const u1 = (inBlueprint: UnknownBlueprint): [UnknownBlueprint, boolean] => {
	console.log('schema-update:process-update:1:unsupported');
	inBlueprint.schemaVersion = 1;
	return [inBlueprint, false];
};
